import clsx from 'clsx'

import { Skeleton } from './Skeleton'

export type PageHeroSkeletonProps = {
  className?: string
  /** Inclui faixa de progresso abaixo do título. */
  withProgress?: boolean
}

/**
 * Placeholder do `PageHero` card (arte + conteúdo, ~100px).
 */
export const PageHeroSkeleton = ({
  className,
  withProgress = false
}: PageHeroSkeletonProps) => (
  <div
    className={clsx(
      'flex min-h-[100px] items-center gap-3 overflow-hidden rounded-2xl border border-contour bg-white p-1 shadow-sm',
      className
    )}
    aria-hidden
  >
    <Skeleton variant="thumb" className="mx-2 h-[76px] w-[76px] shrink-0" />
    <div className="flex min-w-0 flex-1 flex-col justify-center gap-2 py-3 pr-3">
      <Skeleton variant="pill" className="h-4 w-24" />
      <Skeleton className="h-4 w-[82%]" />
      <Skeleton className="h-4 w-[58%]" />
      {withProgress && (
        <div className="flex flex-col gap-1.5 pt-1">
          <div className="flex justify-between gap-2">
            <Skeleton className="h-3 w-[55%]" />
            <Skeleton className="h-3 w-8" />
          </div>
          <Skeleton className="h-2 w-full rounded-full" />
        </div>
      )}
    </div>
  </div>
)
